var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Page-1","stroke":"currentcolor","fill":"none","fillRule":"evenodd","strokeLinecap":"round"},React.createElement("g",{"id":"Mobile-404","transform":"translate(-276.000000, -14.000000)","strokeWidth":"2.5"},React.createElement("g",{"id":"Group-14","transform":"translate(277.000000, 15.000000)"},[React.createElement("path",{"d":"M0.431034483,0.555081081 L24.9983163,0.555081081","id":"Line-4","key":0}),React.createElement("path",{"d":"M0.431034483,9.55508108 L24.9983163,9.55508108","id":"Line-4","key":1}),React.createElement("path",{"d":"M0.431034483,18.5550811 L24.9983163,18.5550811","id":"Line-4","key":2})]))));
}

Menu.defaultProps = {"width":"28px","height":"21px","viewBox":"0 0 28 21","version":"1.1"};

module.exports = Menu;

Menu.default = Menu;
